import { Table, Typography } from 'antd';
import { parseUnknownDate } from '../../../helpers/helpers';

const { Text } = Typography;

const defaultDataSource = [
  {
    key: '1',
    serial: 1,
    poNo: 'PO123456',
    amount: 200000,
    matCost: 150000,
    date: '23-10-2023',
    dueDate: '26-10-2023',
  },
  {
    key: '2',
    serial: 2,
    poNo: 'PO456123',
    amount: 500000,
    matCost: 400000,
    date: '01-11-2023',
    dueDate: '04-11-2023',
  },
];

const columns = [
  {
    title: 'Serial No.',
    dataIndex: 'serial',
    key: 'serial',
  },
  {
    title: 'PO Number',
    dataIndex: 'poNo',
    key: 'poNo',
  },
  {
    title: 'PO Amount',
    dataIndex: 'amount',
    key: 'amount',
  },
  {
    title: 'Material Cost',
    dataIndex: 'matCost',
    key: 'matCost',
  },
  {
    title: 'PO Date',
    dataIndex: 'date',
    key: 'date',
  },
  {
    title: 'PO Due Date',
    dataIndex: 'dueDate',
    key: 'dueDate',
  },
];

const formatToDDMMYYYY = (val) => {
  if (!val) return '-';
  if (typeof val === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(val.trim())) {
    return val.trim();
  }
  if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(val.trim())) {
    const [y, m, d] = val.trim().split('-');
    return `${d}-${m}-${y}`;
  }
  try {
    const parsed = parseUnknownDate(val);
    if (parsed && /^\d{4}-\d{2}-\d{2}$/.test(parsed)) {
      const [y, m, d] = parsed.split('-');
      return `${d}-${m}-${y}`;
    }
  } catch (e) {
    // fallback
  }
  const dateObj = new Date(val);
  if (!isNaN(dateObj.getTime())) {
    const d = String(dateObj.getDate()).padStart(2, '0');
    const m = String(dateObj.getMonth() + 1).padStart(2, '0');
    const y = dateObj.getFullYear();
    return `${d}-${m}-${y}`;
  }
  return String(val);
};

const SupplyChainFormatTable = ({ data }) => {
  const isUploaded = Array.isArray(data) && data.length > 0;

  const dataSource = isUploaded
    ? data.map((row, index) => {
        const rowLower = {};
        Object.entries(row || {}).forEach(([k, v]) => {
          rowLower[String(k).trim().toLowerCase()] = v;
        });
        return {
          key: String(index + 1),
          serial: index + 1,
          poNo:
            rowLower['po number'] ||
            rowLower['po no'] ||
            rowLower['po no.'] ||
            rowLower['purchase order number'] ||
            rowLower['purchase order no'] ||
            row['PO Number'] ||
            '-',
          amount:
            rowLower['po amount'] ||
            rowLower['purchase order amount'] ||
            rowLower['po value'] ||
            row['PO Amount'] ||
            '-',
          matCost:
            rowLower['material cost'] ||
            rowLower['raw material value'] ||
            rowLower['raw material cost'] ||
            row['Material Cost'] ||
            '-',
          date: formatToDDMMYYYY(
            rowLower['po date'] ||
            rowLower['purchase order date'] ||
            row['PO Date']
          ),
          dueDate: formatToDDMMYYYY(
            rowLower['po due date'] ||
            rowLower['purchase order due date'] ||
            row['PO Due Date']
          ),
        };
      })
    : defaultDataSource;

  return (
    <>
      <Text style={{ display: 'block', color: '#40566D', marginBottom: 12, marginTop: 40, fontSize: 14 }}>
        {isUploaded
          ? 'Uploaded summary sheet preview:'
          : 'Ensure your summary sheet follows this format:'}
      </Text>
      <div className="invoice-format-table">
        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={isUploaded && dataSource.length > 5 ? { pageSize: 5, showSizeChanger: false } : false}
          bordered
          scroll={{ x: 'max-content' }}
        />
      </div>
    </>
  );
};

export default SupplyChainFormatTable;
